// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"94eab815","453":"4b03f3bb","796":"2e394a22"}[chunkId] + ".chunk.js";
};